<template>
  <div class="chart-wrap" v-loading="loading">
    <div v-if="!data || !data.length" class="no-data">
      <span>暂无数据</span>
    </div>
    <echart v-else chartId="funnel-chart" :height="height" :options="option">
    </echart>
  </div>
</template>

<script>
import Echart from '@/components/Chart'

export default {
  components: { Echart },
  props: {
    loading: Boolean,
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      height: 170
    }
  },
  computed: {
    option() {
      const data = this.data
        .filter(o => o.qty)
        .map(f => ({ name: f.device, value: f.qty }))
      return {
        title: { show: false },
        legend: {
          bottom: 12,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: { fontSize: 14 },
          padding: 0
        },
        xAxis: { show: false },
        yAxis: { show: false },
        toolbox: { show: false },
        tooltip: {
          trigger: 'item',
          formatter(item) {
            return `
            <div
              style='display: inline-block;
              border-radius: 50%;
              width: 12px;
              height: 12px;
              background-color:${item.color}'
            >
            </div>
            ${item.name} </br>
            ${item.value} ( ${item.percent}% )
            `
          }
        },
        series: [
          {
            type: 'funnel',
            top: 24,
            bottom: 48,
            label: false,
            emphasis: false,
            data
          }
        ]
      }
    }
  },
  mounted() {
    this.height = this.$el.offsetHeight
  }
}
</script>
